<template>
	<div class="row">
		<div class="col-sm-12 col-md-12">
			<b-nav fill tabs>
				<b-nav-item
					v-for="item in items"
					:key="item.title"
					:active="item.active"
					:disabled="item.disabled"
					:to="item.to"
				>{{ $t(item.title) }}</b-nav-item>
			</b-nav>

			<b-card class="bt-parent border-top-0 m-0 rounded-0 mb-4 command-area">
				<div class="row">
					<div class="col-sm-12 col-md-12">
						<slot />
					</div>
				</div>
			</b-card>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['record_id', 'active'],
		data() {
			return {
				items: [],
			}
		},
		methods: {
			init(record_id, title) {
				if (parseInt(record_id) > 0) {
					let items = [
						{title: 'about', disabled: false, active: false},
						{title: 'send', disabled: true, active: false},
					]
					this.items = items.reduce((a, b) => {
						return a.concat({
							...b,
							active: b.title === title,
							disabled: !(parseInt(record_id) > 0),
							to: '/subscription/' + record_id + '/' + b.title,
						})
					}, [])
				}
			},
		},
		watch: {
			record_id(state) {
				console.log(state)
				this.init(state, this.active)
			},
		},
		created() {
			this.init(this.record_id, this.active)
		},
	}
</script>
